export default __webpack_public_path__ + "static/media/wemble.3410aa8b.svg";